import React from "react";
import { useDataContext } from "../context/datacontext";
import { Spinner } from "react-bootstrap";

const Team = () => {
  const ctx = useDataContext();
  const { teamId, myTeamData: team } = ctx;

  if (!team || !team.name) {
    return <Spinner animation="border" role="status" />
  }
  return (
    <div>
      <h1>{team.name}</h1>
      <p>id {teamId}</p>
      <h3>Ranking</h3>
      <p>National: {team.national_rank}</p>
      <p>World: {team.world_rank}</p>
    </div>
  );
};

export default Team;
